export const TRIGGER_TRACKABLE_EVENT = 'TRIGGER_TRACKABLE_EVENT';
